import '../../utilities/graphql/directives.js';
import '../../utilities/graphql/fragments.js';
import '../../utilities/graphql/storeUtils.js';
import '../../utilities/graphql/getFromAST.js';
import '../../utilities/graphql/transform.js';
import Observable from 'zen-observable';
import '../../utilities/common/mergeDeep.js';
import '../../utilities/common/cloneDeep.js';
import '../../utilities/common/maybeDeepFreeze.js';
import '../../utilities/observables/iteration.js';
import '../../utilities/observables/asyncMap.js';
import '../../utilities/observables/Concast.js';
import '../../utilities/common/arrays.js';
import '../../utilities/common/errorHandling.js';
import '../../utilities/common/canUse.js';

function fromError(errorValue) {
  return new Observable(function (observer) {
    observer.error(errorValue);
  });
}

export { fromError };